import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { useCountdown } from '../hooks/useCountdown';
import { PRICE, REGULAR_PRICE } from '../data/offer';
export function Close() {
  const time = useCountdown();
  return <section className="sage-ground w-full border-y-4 border-ochre" data-id="element-55" data-mp="1v0flrsepqdo8">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-56" data-mp="1pygjkluplmsv">
        <h2 className="chalk-underline on-dark font-display text-[28px] text-cream sm:text-5xl" data-id="element-57" data-mp="1l0ezpypgljgc">
          Stop improvising the experiment.{' '}
          <em className="text-ochre-soft" data-id="element-58" data-mp="1g85bcn3zsrg6">Walk into session ready.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-cream/75" data-id="element-59" data-mp="1c8d1m72v4f98">
          129 Experiment Cards, 29 worksheets, six volumes and five bonuses —
          organized so you can find, grade and offer the right experiment in
          minutes, for individual and group work all year.
        </p>

        {!time.expired && <div className="mt-7" data-id="element-60" data-mp="xcx3nqz5vz7k">
            <Countdown time={time} size="sm" tone="dark" data-id="element-61" data-mp="3vevfdmnzyjmu" />
          </div>}

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-ochre/70 bg-ochre/10 px-5 py-4 text-left" data-id="element-62" data-mp="40hbnquwamxf">
          <div data-id="element-63" data-mp="3lj2406m0kw6n">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-ochre" data-id="element-64" data-mp="3lfecte41klv3">
              Complete library
            </span>
            <span className="text-[15px] font-bold text-cream" data-id="element-65" data-mp="i1jzo95ga7az">
              Gestalt Session Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-66" data-mp="82co9ria0mqi">
            <span className="text-[15px] text-cream/55 line-through" data-id="element-67" data-mp="81t4e592fo9u">
              ${REGULAR_PRICE}
            </span>
            <span className="font-display text-4xl leading-none text-cream" data-id="element-68" data-mp="d3ihdqfumc0k">
              ${PRICE}
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-69" data-mp="2xrws22j72o1m">
          <CtaButton data-id="element-70" data-mp="2xpk0cxnmwzbd">Yes, I want the library — ${PRICE}</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-cream/65" data-id="element-71" data-mp="148ecjxequ78h">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-72" data-mp="ui2yhi1cihnv">
              <span className="h-1.5 w-1.5 rounded-full bg-ochre" data-id="element-73" data-mp="pkb32e1hsdex" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}